import {AfterContentInit, Directive, ViewContainerRef} from '@angular/core';

@Directive({
    selector: '[mydocmaStepComponent]'
})
export class StepComponentDirective implements AfterContentInit {

    constructor(private viewContainerRef: ViewContainerRef) {
    }

    public ngAfterContentInit() {
        const hostComponent = this.viewContainerRef['_data'].componentView.component;
        if (!hostComponent.step) {
            return;
        }

        hostComponent.step.component = hostComponent;
    }
}
